import { Component, OnInit, Injectable } from '@angular/core';

@Component({
  selector: 'app-globals',
  templateUrl: './globals.component.html',
  styleUrls: ['./globals.component.css']
})
 
@Injectable()
export class GlobalsComponent  {
  demoRefferURL: string="";
  demoUrl: string ='./assets/blank.html';
  demoHeight:string="500";
  demoWidth:string="200";
  
}

function getCookie(c_name)
{
    var i,x,y,ARRcookies=document.cookie.split(";");

    for (i=0;i<ARRcookies.length;i++)
    {
        x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
        y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
        x=x.replace(/^\s+|\s+$/g,"");
        if (x==c_name)
        {
            return y;
        }
     }
}

export function setScrollCookie() {

  //alert("test  "+"currentPage");
  var cvalue = window.pageYOffset;  
  var exSeconds = 240;
  
  var currentPageArray=document.URL.split("/");
  var cname=currentPageArray[currentPageArray.length-1];
  //var cname = currentPage;
  if((cname.length==0) || (cname=="categories") ) {
    cname="categories";
    exSeconds = 600;
  }
  
  var d = new Date();
  d.setTime(d.getTime() + (exSeconds  * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + '=; expires=Thu, 01-Jan-70 00:00:01 GMT;';
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

export function normalizeCategoryTitleDivHeights() {
  //alert("inside normalize category");
  
  var style = document.createElement('style');
  style.type = 'text/css';
  document.getElementsByTagName('head')[0].appendChild(style);


  var matches = window.document.getElementsByClassName("category-title");
  var maxHeight=0;
 
    for (var i=0; i<matches.length; i++) {
      if (matches[i].clientHeight > maxHeight ) {
        maxHeight = matches[i].clientHeight;
      }
    }
    
    style.innerHTML = '.cssClass { min-height: '+maxHeight+'px; }';
    
    for (var i=0; i< matches.length; i++) {
      matches[i].classList.add('cssClass');
    }
    //alert("ENDING: inside global");
    
     
    var currentPageArray=document.URL.split("/");
    var currentPage=currentPageArray[currentPageArray.length-1];
    if(currentPage.length==0) currentPage="categories";

    var scrollToY = getCookie(currentPage);
    if(!scrollToY) scrollToY=0;
    window.scrollTo(0,Number(scrollToY)* 1.0);  // adjust scrolling  by a % to position tiles correctly
    //alert(document.cookie);
};



export function deactiveNullAnchors() {
  //alert("inside global");
  var style = document.createElement('style');
  style.type = 'text/css';
  document.getElementsByTagName('head')[0].appendChild(style);
  style.innerHTML = '.css2Class {  pointer-events: none; }';

  var matches = window.document.getElementsByClassName("click-through");
  
  for (var i=0; i<matches.length; i++) {
    var elementHTML:string = matches[i].parentElement.innerHTML;
    if (elementHTML.indexOf('nolink')> -1) {
      matches[i].parentElement.classList.add('css2Class');
    }
  }

};




// WEBPACK FOOTER //
// C:/Users/calvi/Documents/AngularProjects/calvinparksportfolio/src/app/components/globals/globals.component.ts